// Character counts complement the form-level Flow validation errors.
import React from "react";

export default function FlowLengthHint({ value, limit }) {
  const count = Array.from(value || "").length;
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        gap: "1em",
        color: count > limit ? "#9c6500" : "#666",
        fontSize: "0.85em",
      }}
    >
      <span>Keep below {limit} characters for WhatsApp Flows</span>
      <span aria-label={`${count} of ${limit} characters`}>
        {count}/{limit}
      </span>
    </div>
  );
}
